export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7616.9669d887.jpg";